import React from 'react';
// import { useLocation } from 'react-router-dom';
import AttendanceTabWrapper from './AttendanceTabWrapper';
import DashboardScreen from './DashboardScreen';

const AttendanceRouteWrapper = () => {
  // Removed unused location variable
  return (
    <DashboardScreen>
      <AttendanceTabWrapper />
    </DashboardScreen>
  );
};

export default AttendanceRouteWrapper;
